"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageStacks6 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var bricks_1 = require("../../bricks");
var ImageStacks6 = function (_a) {
    var heading = _a.heading, cards = _a.cards;
    return ((0, jsx_runtime_1.jsx)("section", __assign({ className: "section-padding-lg bg-secondary" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "container" }, { children: [(0, jsx_runtime_1.jsx)(bricks_1.RowH2Lead, { heading: heading }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "row" }, { children: cards.map(function (card, index) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "col-md-6 col-lg-4 mb-5" }, { children: (0, jsx_runtime_1.jsxs)("a", __assign({ href: card.link, className: "d-block text-default h-100 d-flex flex-column hover-shadow-lg card-hover-bg" }, { children: [(0, jsx_runtime_1.jsx)("img", { src: card.image, className: "img-fluid shadow-sm", alt: "" }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "pt-6 pb-7 px-7 flex-grow-1 d-flex flex-column" }, { children: [(0, jsx_runtime_1.jsx)("h5", __assign({ className: "lh-1-5" }, { children: card.heading })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "small-xs fw-light text-uppercase ls-1-2 mt-auto" }, { children: card.date }))] }))] })) }), index)); }) }))] })) })));
};
exports.ImageStacks6 = ImageStacks6;
